<app-header></app-header>
<div class="container">
	<!-- Loader -->
	<div class="page-loader" *ngIf="loadershow">
		<img src="assets/images/uib-loading-500x500.gif" style="width: 100px" alt="">
	</div>

	<!-- Side nav bar -->
	<div class="row">
		<div class="col-md-3 sideNavBarStyle">
			<div class="sideNavBar">
				<mat-sidenav-container>
					<mat-sidenav #sidenav class="sideNav">
						<mat-nav-list>
							<p class="sideBarP1">
								<button style="white-space: nowrap;" type="button" class="btn btn-info" data-toggle="modal" data-target="#addApplicationModal">{{ 'Application.AddApplication' | translate }}</button>
							</p>
							<p class="sideBarP2">{{ 'Application.MyApplication' | translate }}</p>
							<p *ngFor="let item of applicationList; let i = index" class="sidebar-content">
								<a [ngClass]="{'is-active': clickedItem.id == item.id}" [title] = "item.name" mat-list-item (click)="viewApplicationDetails(item)">{{(item.name.length > 20) ? (item.name | slice:0:20)+'...':(item.name)}} </a>
							</p>
						</mat-nav-list>
					</mat-sidenav>
				</mat-sidenav-container>
			</div>
		</div>

		<!-- Application Content -->
		<div class="col-md-9">
			<div class="sideBarContent" *ngIf="applicationContent ; else isAppicatonContentEmpty">
				<!--Application Name Section-->
				<div class="row">
					<div class="col-md-10 editApplicationStyle">
						<h1 *ngIf="!isEditApplication && !updateApplicationLoader" style="margin: 6% 0% 2% 0%;">{{applicationContent.name}} &nbsp;
							<button type="button" class="btn btn-info" (click)="editApplication()" style="vertical-align: middle;border-radius:5px !important;height: 30px !important;font-size: 14px !important;padding: 5px 8px !important;">
								<i *ngIf="applicationContent" class="fa fa-pencil" aria-hidden="true"></i>
							</button>
						</h1>

						<div *ngIf="isEditApplication" class="updateApplicationStyle">
							<input required class="inputWidthStyle" [(ngModel)]="editedApplicationName" placeholder=""> &nbsp;
							<img alt="" *ngIf="updateApplicationLoader" src="assets/images/uib-loading-500x500.gif" style="width: 20px;margin-left: -5%;margin-right: 2%;">
							<button class="btn btn-info" style="transform: translateY(-10%);border-radius:5px !important;height: 30% !important;font-size: 14px !important;padding: 5px 8px !important;" (click)="updateApplicationName()"><span>Update <i class="fa fa-check" aria-hidden="true"></i></span></button> &nbsp;
							<button class="btn btn-default" style="transform: translateY(-10%);border-radius:5px !important;background-color: #ccc;color: white;height: 30% !important;font-size: 14px !important;padding: 5px 8px !important;" (click)="cancelAppilcationNameEdit()"><span>Cancel <i class="fa fa-times" aria-hidden="true"></i></span></button>
						</div>
  					</div>
					<div class="col-md-2 deleteApplicationStyle">
						<i *ngIf="createdUserCount == 0" class="fa fa-trash-o fa-lg deleteIcon" aria-hidden="true" (click)="deleteApplication()"></i>
					</div>
				</div>

				<!--Application Description Section-->
				<div class="row">
					<div class="col-md-10">
						<h4 *ngIf="applicationContent && (editedApplicationDescription === '' || editedApplicationDescription === null) && !isEditApplicationDescription" style="margin: 3% 0%;">{{ 'Application Description' | translate }} &nbsp;
							<button class="btn btn-info" (click)="editApplicationDescription()" style="vertical-align: bottom;border-radius:5px !important;height: 30px !important;font-size: 14px !important;padding: 5px 8px !important;">
								<i class="fa fa-plus" aria-hidden="true"></i>
							</button>
						</h4>

						<h4 *ngIf="applicationContent && !(editedApplicationDescription === '') && !(editedApplicationDescription === null) && !isEditApplicationDescription" style="margin: 1% 0%;">
							{{applicationContent.description}} &nbsp;

							<button *ngIf="!isEditApplicationDescription" class="btn btn-info" (click)="editApplicationDescription()" style="vertical-align: bottom;border-radius:5px !important;height: 30px !important;font-size: 14px !important;padding: 5px 8px !important;">
								<i *ngIf="applicationContent && !(editedApplicationDescription === '') && !(editedApplicationDescription === null)" class="fa fa-pencil" aria-hidden="true"></i>
							</button>
						</h4>

							<span style="color: red;" *ngIf="isDisabled">This application is currently disabled. Please contact support@uib.ai.</span>

						<div *ngIf="isEditApplicationDescription" style="margin: 1% 0%;">
							<textarea required [(ngModel)]="editedApplicationDescription" style="border: 1px solid lightgray;padding:2%;width:100%;min-height: 150px;max-height: 300px;border-radius:10px;" placeholder="Enter Application Description"></textarea>
							<button class="btn btn-info" style="border-radius:5px !important;height: 30% !important;font-size: 14px !important;padding: 5px 8px !important;transform: translateY(-10%);" (click)="updateApplicationDescription()">Update <i class="fa fa-check" aria-hidden="true"></i></button> &nbsp;
							<button class="btn btn-default" style="border-radius:5px !important;background-color: #ccc;color: white;height: 30% !important;font-size: 14px !important;padding: 5px 8px !important;transform: translateY(-10%);" (click)="cancelAppilcationDescriptionEdit()">Cancel <i class="fa fa-times" aria-hidden="true"></i></button>
						</div>
  					</div>
				</div>
				<hr>
				<h2>{{ 'Application.KeyData' | translate }}
				</h2>
				<hr>
				<table class="table table-bordered dashboard-table">
					<tbody>
						<tr>
							<th>{{ 'Application.UEAppId' | translate }}</th>
							<td>{{applicationContent.applicationId}}</td>
						</tr>
						<tr>
							<th>{{ 'Application.UEAppKey' | translate }}</th>
							<td>{{applicationContent.accessKey}}</td>
						</tr>
						<tr>
							<th>{{ 'Application.UEAppSecret' | translate }}</th>
							<td>{{applicationContent.secret}}</td>
						</tr>
						<tr>
							<th>{{ 'Application.customerId' | translate }}</th>
							<td>

								<span *ngIf="!updateCustomerIdStatus">{{applicationContent.customerId}}</span>
                                <!-- <i class="fa fa-plus iconStyle" aria-hidden="true" (click)='addStatus()'*ngIf="(!applicationContent.customerId || applicationContent.customerId == '') && !addCustomerIdStatus" title="Add Customer Id" style="margin-left: 5px;"></i> -->
								<button class="btn btn-info" (click)='addStatus()'*ngIf="(!applicationContent.customerId || applicationContent.customerId == '') && !addCustomerIdStatus" title="Add Customer Id" style="vertical-align: bottom;border-radius:5px !important;height: 30px !important;font-size: 14px !important;padding: 5px 8px !important;">
									<i class="fa fa-plus" aria-hidden="true"></i>
								</button>
								<!-- <i class="fa fa-pencil iconStyle"  aria-hidden="true"  *ngIf="(applicationContent.customerId || applicationContent.customerId != '') && !updateCustomerIdStatus" (click)='updateStatus()' title="Edit Customer Id" style="margin-left: 5px;"></i> -->
								<button class="btn btn-info"*ngIf="(applicationContent.customerId || applicationContent.customerId != '') && !updateCustomerIdStatus" (click)='updateStatus()' title="Edit Customer Id" style="vertical-align: bottom;border-radius:5px !important;height: 30px !important;font-size: 14px !important;padding: 5px 8px !important;margin-left: 5px;">
									<i class="fa fa-pencil" aria-hidden="true"></i>
								</button>
								<!-- <i class="fa fa-trash iconStyle" aria-hidden="true" (click)='deleteCustomerId()' *ngIf="(applicationContent.customerId || applicationContent.customerId != '') && !updateCustomerIdStatus" title="Delete Customer Id" style="margin-left: 5px;"></i> -->
								<button class="btn btn-info"(click)='deleteCustomerId()' *ngIf="(applicationContent.customerId || applicationContent.customerId != '') && !updateCustomerIdStatus" title="Delete Customer Id" style="vertical-align: bottom;border-radius:5px !important;height: 30px !important;font-size: 14px !important;padding: 5px 8px !important;margin-left: 5px;">
									<i class="fa fa-trash" aria-hidden="true"></i>
								</button>

								<input type="text" *ngIf="addCustomerIdStatus" [(ngModel)]='addCustomerId' style="padding: 5px;border-radius: 10px;border: 1px solid lightgrey;height: 33px;">
								<input type="text" *ngIf="updateCustomerIdStatus" [(ngModel)]='customerId' style="padding: 5px;border-radius: 10px;border: 1px solid lightgrey;height: 33px;">
								&nbsp;<button class="btn btn-info" style="border-radius:5px !important;height: 30% !important;font-size: 14px !important;padding: 5px 8px !important;transform: translateY(-10%);"  *ngIf="addCustomerIdStatus" (click)='customerIdAdd()' >Add <i class="fa fa-check" aria-hidden="true"></i></button>
							    &nbsp;<button class="btn btn-default" style="border-radius:5px !important;background-color: #ccc;color: white;height: 30% !important;font-size: 14px !important;padding: 5px 8px !important;transform: translateY(-10%);" *ngIf="addCustomerIdStatus" (click)='cancelAdd()'>Cancel <i class="fa fa-times" aria-hidden="true"></i></button>
								<!-- &nbsp;<button *ngIf="addCustomerIdStatus" (click)='customerIdAdd()' class="btn btn-primary" style="background-color: 00b0ff ;">Add</button>
								&nbsp;<button *ngIf="addCustomerIdStatus" style="background-color: #e1e1e1;" (click)='cancelAdd()' class="btn btn-default">Cancel</button> -->
								&nbsp;<button class="btn btn-info" style="border-radius:5px !important;height: 30% !important;font-size: 14px !important;padding: 5px 8px !important;transform: translateY(-10%);"  *ngIf="updateCustomerIdStatus" (click)='customerIdUpdate()' >Update <i class="fa fa-check" aria-hidden="true"></i></button>
							    &nbsp;<button class="btn btn-default" style="border-radius:5px !important;background-color: #ccc;color: white;height: 30% !important;font-size: 14px !important;padding: 5px 8px !important;transform: translateY(-10%);" *ngIf="updateCustomerIdStatus" (click)='cancelUpdate()'>Cancel <i class="fa fa-times" aria-hidden="true"></i></button>
								<!-- &nbsp;<button *ngIf="updateCustomerIdStatus" (click)='customerIdUpdate()' class="btn btn-primary" style="background-color: 00b0ff ;">Update</button>
								&nbsp;<button *ngIf="updateCustomerIdStatus" style="background-color: #e1e1e1;" (click)='cancelUpdate()' class="btn btn-default">Cancel</button> -->
							</td>
						</tr>
						<tr>
							<th>{{ 'Application.customerName' | translate }}</th>
							<td>

								<span *ngIf="!updateCustomerNameStatus">{{applicationContent.customerName}}</span>

								<button class="btn btn-info" (click)='addNameStatus()'*ngIf="(!applicationContent.customerName || applicationContent.customerName == '') && !addCustomerNameStatus" title="Add Customer Name" style="vertical-align: bottom;border-radius:5px !important;height: 30px !important;font-size: 14px !important;padding: 5px 8px !important;">
									<i class="fa fa-plus" aria-hidden="true"></i>
								</button>

								<button class="btn btn-info"*ngIf="(applicationContent.customerName || applicationContent.customerName != '') && !updateCustomerNameStatus" (click)='updateNameStatus()' title="Edit Customer Name" style="vertical-align: bottom;border-radius:5px !important;height: 30px !important;font-size: 14px !important;padding: 5px 8px !important;margin-left: 5px;">
									<i class="fa fa-pencil" aria-hidden="true"></i>
								</button>

								<button class="btn btn-info"(click)='deleteCustomerName()' *ngIf="(applicationContent.customerName || applicationContent.customerName != '') && !updateCustomerNameStatus" title="Delete Customer Name" style="vertical-align: bottom;border-radius:5px !important;height: 30px !important;font-size: 14px !important;padding: 5px 8px !important;margin-left: 5px;">
									<i class="fa fa-trash" aria-hidden="true"></i>
								</button>

								<input type="text" *ngIf="addCustomerNameStatus" [(ngModel)]='addCustomerName' style="padding: 5px;border-radius: 10px;border: 1px solid lightgrey;height: 33px;">
								<input type="text" *ngIf="updateCustomerNameStatus" [(ngModel)]='customerName' style="padding: 5px;border-radius: 10px;border: 1px solid lightgrey;height: 33px;">
								&nbsp;<button class="btn btn-info" style="border-radius:5px !important;height: 30% !important;font-size: 14px !important;padding: 5px 8px !important;transform: translateY(-10%);"  *ngIf="addCustomerNameStatus" (click)='customerNameAdd()' >Add <i class="fa fa-check" aria-hidden="true"></i></button>
							    &nbsp;<button class="btn btn-default" style="border-radius:5px !important;background-color: #ccc;color: white;height: 30% !important;font-size: 14px !important;padding: 5px 8px !important;transform: translateY(-10%);" *ngIf="addCustomerNameStatus" (click)='cancelNameAdd()'>Cancel <i class="fa fa-times" aria-hidden="true"></i></button>

								&nbsp;<button class="btn btn-info" style="border-radius:5px !important;height: 30% !important;font-size: 14px !important;padding: 5px 8px !important;transform: translateY(-10%);"  *ngIf="updateCustomerNameStatus" (click)='customerNameUpdate()' >Update <i class="fa fa-check" aria-hidden="true"></i></button>
							    &nbsp;<button class="btn btn-default" style="border-radius:5px !important;background-color: #ccc;color: white;height: 30% !important;font-size: 14px !important;padding: 5px 8px !important;transform: translateY(-10%);" *ngIf="updateCustomerNameStatus" (click)='cancelNameUpdate()'>Cancel <i class="fa fa-times" aria-hidden="true"></i></button>

							</td>
						</tr>
						<tr>
							<th>{{ 'Application.planType' | translate }}</th>
							<td>{{applicationContent.planType}}</td>
						</tr>
						<tr>
							<td colspan="2">
								<a *ngIf="applicationContent.webhookUrl" class="a-class" data-toggle="modal" data-target="#addWebhookDetails">{{ 'Application.UpdateWebhookURL' | translate }}</a>
								<a *ngIf="!applicationContent.webhookUrl" class="a-class" data-toggle="modal" data-target="#addWebhookDetails">{{ 'Application.AddWebhookURL' | translate }}</a>
							</td>
						</tr>
					</tbody>
				</table>

				<!--Generate API Token-->
				<div class="btn-addConnector" style="margin-bottom:1rem;">
					<button type="button" *ngIf="!tokenLoader && apiToken == '' && apiSecret == ''" class="btn btn-info" (click)="generateApiToken()">{{ 'Common.GenerateToken' | translate }}</button>
					<img alt="" *ngIf="tokenLoader" src="assets/images/uib-loading-500x500.gif" style="width: 20px">
					<div *ngIf="!tokenLoader && apiToken !== '' && apiSecret !== ''" style="background-color: rgba(0, 0, 0, 0.03);padding: 1%;font-weight:700;" >
						<span>Make sure you copy the token and store it. It will not be displayed again.</span>
						<br/>
							Access Token: {{apiToken}}
						<br/>
							Access Secret: {{apiSecret}}
					</div>
				</div>

				<!-- addWebhookDetails Modal -->
				<div class="modal fade" role="dialog" id="addWebhookDetails">
					<div class="modal-dialog">
						<div class="modal-content modal-content-webhook">
							<!-- Modal Header -->
							<div class="modal-header">
								<div>
									<h4 class="modal-title">{{ 'Application.AddWebhookURL' | translate }}</h4>
								</div>
								<div>
									<p style="font-size: 16px !important;">{{ 'Application.SetWebhookURL' | translate }}.</p>
								</div>
								<div><button type="button" class="close closeButtonWebhook" data-dismiss="modal">&times;</button></div>
							</div>

							<!-- Modal body -->
							<div class="modal-body">
								<div class="row">
									<!--<div class="web-class">
										{{ 'Application.WebhookURL' | translate }} :
									</div>
									<div class="webValue-class">
										<input type="text" class="form-control inputFieldsWebhook" name="botId" [(ngModel)]="applicationContent.webhookUrl" placeholder="{{applicationContent.webhookUrl}}">
										<span class="alert-error">{{webhookValidateError}}</span>
									</div>-->
										<label class="col-md-3 col-sm-3 col-form-label">{{ 'Application.WebhookURL' | translate }}: </label>
										<div class="col-md-9 col-sm-9">
											<input type="text" class="form-control" name="botId" [(ngModel)]="applicationContent.webhookUrl" placeholder="{{applicationContent.webhookUrl}}">
											<span class="alert-error">{{webhookValidateError}}</span>
										</div>
								</div>
								<div *ngIf="headerArray.length">
									<!--{{ 'Application.Headers' | translate }} :
									<div class="row">
										<div class="col-md-6">
											{{ 'Common.Key' | translate }}
											<div class="row" *ngFor="let item of headerArray;let l = count">
												<input type="text" class="form-control inputFieldsWebhook" name="key" [(ngModel)]="item.key" placeholder="{{ 'Application.HeaderKey' | translate }}">
											</div>
										</div>
										<div class="col-md-6">
											{{ 'Common.Value' | translate }}
											<div class="row" *ngFor="let item of headerArray; let l = count">
												<input type="text" class="form-control inputFieldsWebhook" name="value" [(ngModel)]="item.value" placeholder="{{ 'Application.HeaderValue' | translate }}">
											</div>
										</div>
									</div>-->
									<div class="row">
										<label class="col-md-3 col-sm-3 col-form-label">{{ 'Application.Headers' | translate }}: </label>
										<label class="col-md-4 col-sm-4 col-form-label headerLabelStyle">{{ 'Common.Key' | translate }}</label>
										<label class="col-md-4 col-sm-4 col-form-label headerLabelStyle">{{ 'Common.Value' | translate }}</label>
										<div class="col-md-9 offset-md-3 col-sm-9 offset-sm-3" style="display:inline-flex;margin-bottom: 1%;" *ngFor="let item of headerArray;let l = count">
											<input type="text" class="form-control col-md-6 col-sm-6" style="margin-right: 1%;" name="key" [(ngModel)]="item.key" placeholder="{{ 'Application.HeaderKey' | translate }}">
											<input type="text" class="form-control col-md-6 col-sm-6" name="value" [(ngModel)]="item.value" placeholder="{{ 'Application.HeaderValue' | translate }}">
										</div>
									</div>
								</div>
							</div>

							<!-- Modal footer -->
							<div class="modal-footer">
								<button type="button" class="btn btn-default" data-dismiss="modal">{{ 'Common.Cancel' | translate }}</button>
								<button type="button" class="btn btn-info" (click)="addWebhookDetails()">{{ 'Common.Submit' | translate }}</button>
							</div>
						</div>
					</div>
				</div>

				<table class="table table-bordered dashboard-table" style="width:50%;">
					<tbody>
					  	<tr>
							<th>{{ 'Application.MessageSent' | translate }}</th>
							<td style="width:15%;overflow-wrap: break-word;text-align: end;">
								<img alt="" *ngIf="totalSentMessageLoader" src="assets/images/uib-loading-500x500.gif" style="width: 20px">
								<span style="display:grid;">
									{{ totalSentMessages | number:'1.' }}
									<a *ngIf="!totalSentMessageLoader" class="countShowAnchor" style="font-size:15px;" data-toggle="modal" (click)="countDetailsShow('msgSent','')">Details</a>
								</span>
							</td>
						</tr>
					  	<tr>
							<th>{{ 'Application.MessageSentOnRenewal' | translate }}</th>
							<td style="width:15%;overflow-wrap: break-word;text-align: end;">
								<img alt="" *ngIf="totalSentMessageAfterRenewedLoader" src="assets/images/uib-loading-500x500.gif" style="width: 20px">
								<label *ngIf="!totalSentMessageAfterRenewedLoader" class="countShowAnchor" style="cursor:context-menu;color:black;">
									{{ totalSentMessagesAfterRenewed | number:'1.' }}
								</label>
							</td>
						</tr>
						<tr>
							<th>{{ 'Application.UsersCreated' | translate }}</th>
							<td style="width:15%;overflow-wrap: break-word;text-align: end;">
								<img alt="" *ngIf="createdUserCountLoader" src="assets/images/uib-loading-500x500.gif" style="width: 20px">
								<span style="display:grid;">
									{{ createdUserCount | number:'1.' }}
									<a style="font-size:15px;" *ngIf="!createdUserCountLoader" class="countShowAnchor" data-toggle="modal" (click)="countDetailsShow('user','')">Details</a>
								</span>
							</td>
						</tr>
						<tr>
							<th>{{ 'Application.MessagesReceived' | translate }}</th>
							<td style="width:15%;overflow-wrap: break-word;text-align: end;">
								<img alt="" *ngIf="totalReceivedMessageLoader" src="assets/images/uib-loading-500x500.gif" style="width: 20px">
								<span style="display:grid;">
									{{ totalReceivedMessages | number:'1.' }}
									<a style="font-size:15px;" *ngIf="!totalReceivedMessageLoader" class="countShowAnchor" data-toggle="modal" (click)="countDetailsShow('msgReceived','')">Details</a>
								</span>
							</td>
						</tr>
						<tr>
							<th>{{ 'Application.MessagesReceivedOnRenewal' | translate }}</th>
							<td style="width:15%;overflow-wrap: break-word;text-align: end;">
								<img alt="" *ngIf="totalReceivedMessageAfterRenewedLoader" src="assets/images/uib-loading-500x500.gif" style="width: 20px">
								<label *ngIf="!totalReceivedMessageAfterRenewedLoader" class="countShowAnchor" style="cursor:context-menu;color:black;">
									{{ totalReceivedMessagesAfterRenewed | number:'1.'}}
								</label>
							</td>
						</tr>
						<tr *ngIf="whatsAppConnFilter && whatsAppConnFilter.length > 0">
							<th>{{ 'Application.TemplateMessageOnSent' | translate }}</th>
							<td style="width:15%;overflow-wrap: break-word;text-align: end;">
								<img alt="" *ngIf="totalTempalteLoader" src="assets/images/uib-loading-500x500.gif" style="width: 20px">
								<span style="display:grid;">
									{{ totalTemplate | number:'1.' }}
									<a style="font-size:15px;" *ngIf="!totalTempalteLoader" class="countShowAnchor" data-toggle="modal" (click)="countDetailsShow('templateCo','')">Details</a>
								</span>
							</td>
						</tr>
						<tr *ngIf="whatsAppConnFilter && whatsAppConnFilter.length > 0">
							<th>{{ 'Application.receivedNotificationMessage' | translate }}</th>
							<td style="width:15%;overflow-wrap: break-word;text-align: end;">
								<img alt="" *ngIf="receivedNotificationMessageLoader" src="assets/images/uib-loading-500x500.gif" style="width: 20px">
								<span style="display:grid;">
									{{ receivedNotificationMsgCount | number:'1.' }}
									<a style="font-size:15px;" *ngIf="!receivedNotificationMessageLoader" class="countShowAnchor" data-toggle="modal" (click)="countDetailsShow('receivedNotification','')">Details</a>
								</span>
							</td>
						</tr>
						<tr *ngIf="activemonthlyusersboolean">
							<th>Current month active users</th>
							<td style="width:15%;overflow-wrap: break-word;text-align: end;">
								<img alt="" *ngIf="activeMonthlyUsersLoader" src="assets/images/uib-loading-500x500.gif" style="width: 20px">
								<span style="display:grid;">
									{{ activeMonthlyUsers | number:'1.' }}
									<a style="font-size:15px;" *ngIf="!activeMonthlyUsersLoader" class="countShowAnchor" data-toggle="modal" (click)="countDetailsShow('activeUser','')">Details</a>
								</span>
							</td>
						</tr>
						<tr>
							<th>{{ 'Application.audioDuration' | translate }}</th>
							<td style="width:15%;overflow-wrap: break-word;text-align: end;">
								<img alt="" *ngIf="audioReceivedTotalDurationLoader" src="assets/images/uib-loading-500x500.gif" style="width: 20px">
								<span style="display:grid;">
									<div style="white-space: nowrap;">{{ audioReceivedTotalDuration }}</div>
									<a style="font-size:15px;" *ngIf="!audioReceivedTotalDurationLoader" class="countShowAnchor" data-toggle="modal" (click)="countDetailsShow('audioDuration','')">Details</a>
								</span>
							</td>
						</tr>

						<tr>
							<th>{{ 'Application.downloadReportUsage' | translate }}</th>
							<td style="width:15%;overflow-wrap: break-word;text-align: center;">
								<!-- <img *ngIf="receivedNotificationMessageLoader" src="assets/images/uib-loading-500x500.gif" style="width: 20px"> -->
								<a  class="countShowAnchor" data-toggle="modal" data-target="#downloadReport" (click)="clickDownloadReport()">
									<i class="fa fa-download" style="padding-left: 0px;font-size: 20px;"></i>
								</a>
							</td>
						</tr>

					</tbody>
				</table>

				<!-- <p>Enable translation for all incoming text to:
					<select name="taranslationLang" id="taranslationLang" (change)="setTranslationLanguage($event)">
						<option *ngFor="let lang of languageTranslate" value="{{lang.value}}" [selected]="applicationContent.translationLanguage == lang.value">{{lang.language}}</option>
					</select>
				</p> -->

				<!-- <p>
					<i class="fa fa-info-circle tooltip" aria-hidden="true">
						<span class="tooltiptext-text">If enabled, all response text from the NLP will be auto translated to the input text language sent by the user.</span>
					</i> {{ 'Application.EnableTrans' | translate }}:
					<input type="checkbox" name="enableTrans" [(ngModel)]="applicationContent.translate" [checked]="applicationContent.translate" [disabled]="enabilecheckbox || applicationContent.translationLanguage == 'null'" (change)="enableTranslation($event)" />
				</p> -->

				<!--Commented Callback Persist on Live-->
				<!--<p>
					{{ 'Application.callbackpersist' | translate }}:
					<input type="checkbox" name="enable" [checked]="callbackper" (change)="callbackpersist($event)" />
					<select class='select-option' #mySelect *ngIf="callbackper" name="callbackPersistCount" id="callbackPersistCount"  style="margin-left:2%; height:84%;" (change)="callbackPersistCountChange(mySelect.value)">
						<option class='option' *ngFor="let count of resTranslationCount" [value]="count"
						[selected]="applicationContent.numberOfCallback == count" >{{count}}</option>
					</select>
				</p>-->

				<h2>{{ 'Common.Connectors' | translate }}</h2>
				<hr>
				<div *ngIf="showSuccess">
					<p>{{ 'Application.appAddSuccess1' | translate }}</p>
					<p>{{ 'Application.appAddSuccess2' | translate }}</p>
				</div>
				<div *ngFor="let connection of connectorDetails; let i = index">
					<div class="accordion" id="accordionExample">
						<div class="card z-depth-0 bordered">
							<div class="card-header" id="headingOne">
								<h5 class="mb-0">
									<div class="btn" (click)="closeConnector(connection, i)" data-toggle="collapse" attr.data-target="#collapseOne{{i}}" aria-expanded="true" attr.aria-controls="collapseOne{{i}}">
										<img alt="" *ngIf="connection.icon !== null && connection.icon !== ''" class="iconAddConnector" [src]="connection.icon">
										<img alt="" *ngIf="connection.icon == null || connection.icon == ''" class="iconAddConnector" src="assets/images/connector.png">
										{{connection.name}} <i class="fa fa-angle-right" aria-hidden="true"></i>
									</div>
									<div class="publicKeyClass">
										<i class="fa fa-files-o iconClass" aria-hidden="true" title="copy public key" (click)="copyKey(connection.publicKey)"></i>
										<i class="fa fa-trash-o iconClass" aria-hidden="true" (click)="deleteConnector(connection.id)"></i>
									</div>
								</h5>
							</div>
							<div id="collapseOne{{i}}" *ngIf="connection.hideBox" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
								<div class="card-body">
									<div class="panel-body">
										<div class="row con-list">
											<div class="col-md-4">
												<label>{{ 'Application.SchemeUsed' | translate }}:</label>
											</div>
											<div class="col-md-8">
												<label>{{connection.scheme}}</label>
											</div>
										</div>
										<div class="row con-list" *ngIf="connection.messagingConnector == true && connection.pollCapablity != true">
											<div class="col-md-4">
												<label>{{connection.name}}
													{{ 'Application.AppWebhookURL' | translate }}:
												</label>
											</div>
											<div class="col-md-8">
												<label>{{connection.endPoint}}</label>
											</div>
										</div>
										<div class="row con-list">
											<div class="col-md-4">
												<label>{{ 'Application.NumConnections' | translate }}: </label>
											</div>
											<div class="col-md-8">
												<img alt="" *ngIf="connectionLoader" src="assets/images/uib-loading-500x500.gif" style="width: 20px">
												<label *ngIf="!connectionLoader" >{{ connection.connectionCount }}</label>
											</div>
										</div>
										<div class="row con-list" *ngIf="connection.messagingConnector == true">
											<div class="col-md-4" *ngIf="!checkLabelretiveName(connection)">
												<label>{{ 'Application.NumMessagesSent' | translate }}: </label>
											</div>
											<div class="col-md-4" *ngIf="checkLabelretiveName(connection)">
												<label>{{ 'Application.NumMessagesRetrive' | translate }}: </label>
											</div>
											<div class="col-md-8">
												<label>
													<img alt="" *ngIf="sentCountLoader" src="assets/images/uib-loading-500x500.gif" style="width: 20px">
													<a *ngIf="!sentCountLoader" class="countShowAnchor" data-toggle="modal" (click)="countDetailsShow('connectorMsgSent',connection.id)">
														{{ connection.sentCount }}
													</a>
												</label>
											</div>
										</div>
										<div class="row con-list" *ngIf="connection.messagingConnector == true">
											<div class="col-md-4" *ngIf="!checkLabelretiveName(connection)">
												<label>{{ 'Application.NumMessagesSentAfterRenewal' | translate }}: </label>
											</div>
											<div class="col-md-4" *ngIf="checkLabelretiveName(connection)">
												<label>{{ 'Application.NumMessagesRetriveAfterRenewal' | translate }}: </label>
											</div>
											<div class="col-md-8">
												<label>
													<img alt="" *ngIf="sentCountAfterRenewalLoader" src="assets/images/uib-loading-500x500.gif" style="width: 20px">
													<a *ngIf="!sentCountAfterRenewalLoader" class="countShowAnchor" data-toggle="modal" style="cursor:context-menu; color:black;">
														{{ connection.sentCountAfterRenewal }}
													</a>
												</label>
											</div>
										</div>
										<div class="row con-list" *ngIf="connection.messagingConnector == true && connection.hasHsm">
											<div class="col-md-4">
												<label>{{ 'Application.NumHsmMessages' | translate }}: </label>
											</div>
											<div class="col-md-8">
												<label>
													<img alt="" *ngIf="hsmCountLoader" src="assets/images/uib-loading-500x500.gif" style="width: 20px">
													<a *ngIf="!hsmCountLoader" class="countShowAnchor" data-toggle="modal" (click)="countDetailsShow('connectorHsmMsgSent',connection.id)">
														{{connection.hsmCount}}
													</a>
												</label>
											</div>
										</div>
										<div class="row con-list">
											<div class="col-md-4">
												<label>{{ 'Application.UserAuthType' | translate }}:</label>
											</div>
											<div class="col-md-8">
												<label>{{connection.accessToken}}</label>
											</div>
										</div>
										<div class="row con-list">
											<div class="col-md-4">
												<label>{{ 'Application.AppKey' | translate }}:</label>
											</div>
											<div class="col-md-8">
												<label>{{connection.applicationKey}}</label>
											</div>
										</div>
										<!--<div class="row con-list">
											<div class="col-md-4">
												<label>Application Secret:</label>
											</div>
											<div class="col-md-8">
												<label>{{connection.applicationSecret}}</label>
											</div>
										</div>-->
										<div class="row con-list" *ngIf="connection.optionalParams">
											<div class="col-md-4">
												<label>{{ 'Application.OptionalParams' | translate }}:</label>
											</div>
											<div class="col-md-8">
												<label *ngFor="let con of connection.optionalParams | keyvalue">
													<p>{{con.key}}: {{con.value}}</p>
												</label>
											</div>
										</div>
										<div class="row con-list" style="padding-bottom: 0px" >
											<div class="col-md-4">
												<label>{{ 'Application.AppURLHandle' | translate }}:</label>
											</div>
											<div class="col-md-8">
												<label>
													<p *ngIf="!isEditApplicationURLHandle">
														{{connection.urlHandle ? connection.urlHandle : 'N/A'}} &nbsp;
														<button type="button" class="btn" (click)="$event.preventDefault();$event.stopPropagation();editApplicationURLHandle(connection);" style="font-size: 14px !important;">
															<i *ngIf="applicationContent" class="fa fa-pencil-square-o" aria-hidden="true"></i>
														</button>
													</p>
													<p *ngIf="isEditApplicationURLHandle">
														<input required class="inputWidthStyle" [(ngModel)]="editedApplicationURLHandle" placeholder="{{ 'Application.AppURLHandle' | translate }}"> &nbsp;
														<img alt="" *ngIf="updateApplicationURLHandleLoader" src="assets/images/uib-loading-500x500.gif"  style="width: 20px;margin-left: -5%;margin-right: 2%;">
														<button title="Update" class="btn btn-info" style="transform: translateY(-10%);border-radius:5px !important;height: 30% !important;font-size: 14px !important;padding: 5px 8px !important;" (click)="$event.preventDefault();$event.stopPropagation();updateApplicationURLHandle(connection);">
															<i class="fa fa-check" aria-hidden="true"></i>
														</button> &nbsp;
														<button title="Cancel" class="btn btn-default" style="transform: translateY(-10%);border-radius:5px !important;background-color: #ccc;color: white;height: 30% !important;font-size: 14px !important;padding: 5px 8px !important;" (click)="$event.preventDefault();$event.stopPropagation();cancelApplicationURLHandleEdit();">
															<i class="fa fa-times" aria-hidden="true"></i>
														</button>
													</p>
												</label>
											</div>
										</div>
										<div class="row con-list" *ngIf="connection.messagingConnector == true && !(connection.scheme === 'whatsapptrial'|| connection.scheme ==='whatsappsandbox' || connection.scheme ==='whatsappcloudsandbox')" >
                      <div class="col-md-4"  >
                      <label>{{ 'Application.BotDetails' | translate }}:
													<a *ngIf="!connection.botDetails" class="botDetailsAnchor">
														<i class="fa fa-plus-circle" data-toggle="modal" attr.data-target="#addBotDetails{{i}}" aria-hidden="true"></i>
													</a>
												</label>
                        </div>
											<div class="col-md-8">
												<div class="botDetailsDiv" *ngFor="let bot of connection.botDetails | keyvalue;let j = index">
													<div>
														<i data-toggle="modal" attr.data-target="#updateBotDetails{{i}}{{j}}" class="fa fa-pencil-square-o" aria-hidden="true"></i>
														<i class="fa fa-trash-o" aria-hidden="true" (click)="deleteBotDetails(bot,connection)"></i>
													</div>
													<p> {{ 'Application.Botid' | translate }}: {{ bot.key }} </p>
													<p> {{ 'Application.WebhookURL' | translate }}: {{ bot.value }}
													</p>
													<!-- updateBotDetails Modal -->
													<div class="modal fade" role="dialog" id="updateBotDetails{{i}}{{j}}">
														<div class="modal-dialog">
															<div class="modal-content modal-content-login">
																<!-- Modal Header -->
																<div class="modal-header">
																	<div>
																		<h4 class="modal-title">
																			{{ 'Application.AddBotDetails' | translate }}
																		</h4>
																	</div>
																	<div>
																		<p>{{ 'Application.EditRegURL' | translate }}
																			{{connection.name}}
																			{{ 'Application.AppAny' | translate }}.</p>
																	</div>
																	<div>
																		<button type="button" class="close closeButton" data-dismiss="modal">&times;</button>
																	</div>
																</div>

																<!-- Modal body -->
																<div class="modal-body">
																	<input type="text" class="form-control inputFields" name="updatebotId" [(ngModel)]="bot.key" disabled>
																	<input type="text" class="form-control inputFields" name="updateRegistrationUrl" [(ngModel)]="bot.value">
																	<span class="alert-error" style="padding-left: 50px;">{{urlRequiredError}}</span>
																</div>

																<!-- Modal footer -->
																<div class="modal-footer">
																	<button type="button" class="btn btn-default" data-dismiss="modal">{{ 'Common.Cancel' | translate }}</button>
																	<button type="button" class="btn btn-info botSubmit" (click)="updateBotDetails(bot,connection,i,j)">{{ 'Common.Submit' | translate }}</button>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
<!--..................................................................................................................-->
											<!-- addBotDetails Modal -->
											<div class="modal fade" role="dialog" id="addBotDetails{{i}}">
												<div class="modal-dialog">
													<div class="modal-content modal-content-login">
														<!-- Modal Header -->
														<div class="modal-header">
															<div>
																<h4 class="modal-title">Add bot details</h4>
															</div>
															<div>
																<p>{{ 'Application.EditRegURL' | translate }}
																	{{connection.name}}
																	{{ 'Application.AppAny' | translate }}.</p>
															</div>
															<div>
																<button type="button" class="close closeButton" data-dismiss="modal" (click)="clearBotDetails()">&times;
																</button>
															</div>
														</div>

														<!-- Modal body -->
														<div class="modal-body">
															<input type="text" class="form-control inputFields" name="botId" [(ngModel)]="botId" placeholder="{{ 'Application.Botid' | translate }}" required>
															<span class="alert-error">{{botIdRequiredError}}</span>
															<input type="text" class="form-control inputFields" name="registrationUrl" [(ngModel)]="registrationUrl" placeholder="{{ 'Application.WebhookURL' | translate }}" required>
															<span class="alert-error">{{urlRequiredError}}</span>
														</div>

														<!-- Modal footer -->
														<div class="modal-footer">
															<button type="button" class="btn btn-default" data-dismiss="modal" (click)="clearBotDetails()">{{ 'Common.Cancel' | translate }}</button>
															<button type="button" class="btn btn-info botSubmit" (click)="addBotDetails(connection,i)">{{ 'Common.Submit' | translate }}</button>
														</div>
													</div>
												</div>
											</div>
										</div>
<!------------------------------------------------------------------------------------------------------------------>
										<!-- <div class="row con-list">
											<div class="col-md-4">
												<label>{{ 'Application.AppQrCode' | translate }}:</label>
											</div>
											<div class="col-md-8">
												<div *ngIf = "!connection.channelQrCode">
												<label  for="file-input-edit"  style="cursor: pointer;">
													<span ><img alt="" style="width: 13px;" src="assets/images/paperclip.png">Attach (.jpeg, .png)</span></label>
													<input  #fileInputEdit id="file-input-edit" type="file"	accept="image/*"
													(change)="processFileEdit($event)" class="custom-file-input" style="display: none;">
												</div>
												<div style="padding: 5px 2px;"*ngIf="connection.channelQrCode" class="img-wrap">
													<img alt="" style="width: 50px;" [src]="connection.channelQrCode">
													<span (click)="imageCrossClick();" class="closeAttach"
														style="cursor: pointer;">&times;</span>
												</div>
												<div style="padding: 5px 5px" *ngIf="uploadloader && !connection.channelQrCode">
                                       			 <img alt="" src="assets/images/uib-loading-500x500.gif" style="width: 8%" /></div>
											</div>
										</div> -->
										<div class="row con-list">
											<div class="col-md-4">
												<label>{{ 'Common.PublicKey' | translate }}:</label>
											</div>
											<div class="col-md-8">
												<label>{{connection.publicKey}}</label>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="btn-addConnector">
					<button type="button" *ngIf="isDisabled"  class="btn btn-info" data-toggle="modal" data-target="#addConnector" disabled style="pointer-events: none;">{{ 'Common.AddConnector' | translate }}</button>
					<button type="button" *ngIf="!isDisabled" class="btn btn-info" data-toggle="modal" data-target="#addConnector">{{ 'Common.AddConnector' | translate }}</button>
				</div>
			</div>
			<ng-template #isAppicatonContentEmpty>
				<div class="isAppicatonContent ">
					<h1>{{ 'Common.GetStarted' | translate }}</h1>
					<hr>
					<p> {{ 'Application.EmptyContent' | translate }} <br>
						{{ 'Application.EmptyContent1' | translate }}
					</p>
				</div>
			</ng-template>
		</div>
	</div>
</div>
<app-footer></app-footer>

<!-- addApplicationModal Modal -->
<div class="modal fade" role="dialog" id="addApplicationModal">
	<div class="modal-dialog">
		<div class="modal-content modal-content-login">
			<!-- Modal Header -->
			<div class="modal-header">
				<div>
					<h4 class="modal-title">{{ 'Application.AddApplication' | translate }}</h4>
				</div>
				<div>
					<p>{{ 'Application.GivAppName' | translate }}.</p>
				</div>
				<div>
					<button type="button" class="close closeButton" (click)="closeModelHeader()" data-dismiss="modal">&times;</button>
				</div>
			</div>

			<!-- Modal body -->
			<div class="modal-body">
				<input type="text" class="form-control inputFields" name="applicationName" [(ngModel)]="applicationName" placeholder="{{ 'Application.AppName' | translate }}" required>
				<span class="alert-error" style="margin-left:18% !important;">{{appNameRequiredError}}</span>

				<textarea class="form-control inputFields" name="applicationDescription" [(ngModel)]="applicationDescription" placeholder="{{ 'Application.Description' | translate }}"></textarea>
				<!--<span class="alert-error">{{appNameRequiredError}}</span>-->
			</div>

			<!-- Modal footer -->
			<div class="modal-footer">
				<button type="button" class="btn btn-default" (click)="closeModelHeader()" data-dismiss="modal">{{ 'Common.Cancel' | translate }}</button>
				<button type="button" class="btn btn-info" (click)="addApplication()">{{ 'Common.Submit' | translate }}</button>
			</div>
		</div>
	</div>
</div>

<!-- addConnector Modal -->
<div class="modal fade" role="dialog" id="addConnector" >
	<div class="modal-dialog modal-lg">
		<div class="modal-content modal-content-connector">
			<!-- Modal Header -->
			<div class="modal-header">
				<div><button type="button" class="close" data-dismiss="modal" (click)="closeModel()">&times;</button>
				</div>
				<div>
					<h4 class="modal-title">{{ 'Common.AddConnector' | translate }}: {{ tabName }}</h4>
				</div>
			</div>

			<!-- Modal body -->
			<div class="modal-body addConClass">
				<div class="">
					<!-- <div id="content">
				<div id="main-content"> -->
					<mat-tab-group [(selectedIndex)]="selectedIndex" (selectedTabChange)="tabChanged($event)">
						<mat-tab label="Connector">
							<div class="row chooseConClass">{{ 'Application.ChooseConnector' | translate }}</div>
							<div class="" style="margin-bottom: 5px;margin-left: -4px;">
								<input type="radio" name="connectorType" (click)="connectorType($event)" value="Messaging" style="margin:5px;">Messaging
								<input type="radio" name="connectorType" (click)="connectorType($event)" value="IoT" style="margin:5px;">IoT
								<input type="radio" name="connectorType" (click)="connectorType($event)" value="Other" style="margin:5px;">Other
								<br><span *ngIf="connectorSelected" style="margin-left: 4px;">Connector selected: {{connectorSelected}}</span>
							</div>
							<div style="margin-bottom: 10px;">
								<!-- <i class="fa fa-search" aria-hidden="true"></i>
								<span  style="position: absolute;right: 2em;top: 50%;transform: translate(0,-50%);font-weight: 700;color: #BDBDBD;cursor: pointer;" (click)="clearClick();" *ngIf="search != ''">
								 <i class="fa fa-times"  aria-hidden="true"></i>
								</span> -->

								<input type="text" [(ngModel)]="search" (keyup)="onKeyup(search)" i18n-placeholder="@@search" placeholder="Search"
								  class="form-control form-cotrol-question" style="height: 40px;border: none;" name="search"  autocomplete="off">
							</div>
							<div class="matBodyRadioDiv">
								<div class="row" *ngIf="noRecordsFound" style="background-color:transparent !important;margin-left: 5px;margin-top: 25px;"><span >No records found</span></div>
								<div class="row" *ngFor="let connector of addConnectorDetails">
									<div class="col-md-11 inputRadioStyle">
										<!-- <input type="radio" class="matBodyRadio" [(ngModel)]="selectedConnector"
											value="{{connector.id}}" (change)="selectConnector()"> -->
										<input type="radio" class="matBodyRadio" [(ngModel)]="selectedConnector" value="{{connector.name}},{{connector.id}}" (ngModelChange)="onModelChange($event, connector)">
										<img alt="" *ngIf="connector.icon !== null && connector.icon !== ''" class="iconAddConnector" [src]="connector.icon">
										<img alt="" *ngIf="connector.icon == null || connector.icon == ''" class="iconAddConnector" src="assets/images/connector.png">
										{{connector.name}}
									</div>
									<div class="tooltip col-md-1" (mouseover)="displayTooltip(connector.capabilities)">
										<i class="fa fa-info-circle matdivInfo" aria-hidden="true"></i>
										<span class="tooltiptext">{{ 'Application.Capabilities' | translate }}:
											{{tooltipContent}}</span>
									</div>
								</div>
							</div>
						</mat-tab>
						<mat-tab label="Choose Method" *ngIf="connectorName === 'WhatsappOfficial' && !whatsappConnecterAdded">
							<div class="confirm-div">
								<div class="row">
									<div >
										<label *ngIf="selectedConnectorDetails">
											<div class="form-group" style="display:block;text-align: left;padding-top: 14px;">
												<label style="padding-left: 20px;">Choose method</label>
											</div>
											<div class="form-group" style="display:inline-flex;padding:0px;">
												<div style="padding-left: 20px;">
                                                    <label class="radio-inline question-form-label" >
                                                        <input type="radio" id="manual" style="margin-top: 1px;"
                                                            [(ngModel)]="connectorValue" name="radio_activity"
                                                            value="manual" (change)="radioValueChange('manual')" checked>
                                                        Manual
                                                    </label>
                                                    <label  style="padding-left:20px;" class="radio-inline question-form-label" >
                                                        <input type="radio" id="embeddedSignUp" style="margin-top: 1px;"
                                                            name="radio_activity" [(ngModel)]="connectorValue"
                                                            value="embeddedSignUp" (change)="radioValueChange('embeddedSignUp')">
															Embedded SignUp
                                                    </label>
                                                </div>
											 </div>
										</label>
									</div>
								</div>
							</div>
						</mat-tab>
						<mat-tab label="Credentials">
							<div class="credential-class">
								<label *ngIf="selectedConnectorDetails && ((selectedConnectorDetails.name === 'WhatsappOfficial' && connectorValue === 'manual') || selectedConnectorDetails.name !== 'WhatsappOfficial' && selectedConnectorDetails.name !== 'Fbmessenger' && selectedConnectorDetails.name !== 'Airbnb' && selectedConnectorDetails.name !== 'Twitch' && selectedConnectorDetails.name !== 'Instagram' && selectedConnectorDetails.name !== 'WhatsApp Cloud' && selectedConnectorDetails.name !== 'Twitter')">{{ 'Application.EnterKeySecret' | translate }}
									{{ selectedConnectorDetails.name }} {{ 'Common.Application' | translate }}.</label>
								<div *ngIf="selectedConnectorDetails && selectedConnectorDetails.name === 'Fbmessenger'" style="margin:1%;">
									<button class="btn btn-info conNext" type="button" (click)="fblogin()" style="color:white;cursor:pointer;width:auto;">
										Connect Facebook
									</button>
									<p style="color:red;font-size: 13px;margin-top: 10px;">{{connectorError}}</p>
								</div>
								<div *ngIf="selectedConnectorDetails && selectedConnectorDetails.name === 'Airbnb'" style="margin:1%;">
									<button class="btn btn-info conNext" type="button" (click)="airbnblogin()" style="color:white;cursor:pointer;width:auto;">
										Connect Airbnb
									</button>
									<p style="color:red;font-size: 13px;margin-top: 10px;">{{airbnbconnectorError}}</p>
								</div>
								<div *ngIf="selectedConnectorDetails && selectedConnectorDetails.name === 'Twitch'" style="margin:1%;">
									<button class="btn btn-info conNext" type="button" (click)="twitchlogin()" style="color:white;cursor:pointer;width:auto;">
										Connect Twitch
									</button>
									<p style="color:red;font-size: 13px;margin-top: 10px;">{{twitchconnectorError}}</p>
								</div>
								<div *ngIf="selectedConnectorDetails && selectedConnectorDetails.name === 'Instagram'" style="margin:1%;">
									<button class="btn btn-info conNext" type="button" (click)="instagramlogin()" style="color:white;cursor:pointer;width:auto;">
										Connect Instagram
									</button>
									<p style="color:red;font-size: 13px;margin-top: 10px;">{{instagramconnectorError}}</p>
								</div>
                <!-- <div *ngIf="selectedConnectorDetails && selectedConnectorDetails.name === 'TikTok'" style="margin:1%;">
									<button class="btn btn-info conNext" type="button" (click)="tiktoklogin()" style="color:white;cursor:pointer;width:auto;">
										Connect TikTok
									</button>
									<p style="color:red;font-size: 13px;margin-top: 10px;">{{instagramconnectorError}}</p>
								</div> -->
								<div *ngIf="selectedConnectorDetails && selectedConnectorDetails.name === 'Twitter'" style="margin:1%;">
									<button class="btn btn-info conNext" type="button" (click)="twitterlogin()" style="color:white;cursor:pointer;width:auto;">
										Connect Twitter
									</button>
									<p style="color:red;font-size: 13px;margin-top: 10px;">{{twitterconnectorError}}</p>
								</div>
								<!-- <div *ngIf="selectedConnectorDetails && selectedConnectorDetails.name === 'WhatsApp Cloud'" style="margin:1%;"> -->
								<div *ngIf="selectedConnectorDetails && ((selectedConnectorDetails.name === 'WhatsappOfficial' && connectorValue === 'embeddedSignUp' && !whatsappConnecterAdded ) || selectedConnectorDetails.name === 'WhatsApp Cloud')" style="margin:1%;">
									<button class="btn btn-info conNext" type="button" (click)="whatsappCloudlogin()" style="color:white;cursor:pointer;width:auto;" [disabled] = "selectedConnectorDetails.name === 'WhatsApp Cloud' && whatsappCloudConnecterAdded">
										Connect WhatsApp
									</button>
									<p *ngIf="selectedConnectorDetails.name === 'WhatsApp Cloud' && whatsappCloudConnecterAdded" style="color:red;font-size: 13px;margin-top: 10px;">WhatsApp Cloud is already added in this application</p>
									<!-- <p style="color:red;font-size: 13px;margin-top: 10px;">{{instagramconnectorError}}</p> -->
								</div>
								<!-- <div *ngIf="selectedConnectorDetails  && connectorValue !== 'embeddedSignUp' && selectedConnectorDetails.name !== 'Fbmessenger' && selectedConnectorDetails.name !== 'Airbnb' && selectedConnectorDetails.name !== 'Twitch' && selectedConnectorDetails.name !== 'Instagram' && selectedConnectorDetails.name !== 'WhatsApp Cloud'"> -->
								<div *ngIf="selectedConnectorDetails && ( (selectedConnectorDetails.name === 'WhatsappOfficial' && connectorValue === 'manual') || (selectedConnectorDetails.name !== 'WhatsappOfficial' && selectedConnectorDetails.name !== 'Fbmessenger' && selectedConnectorDetails.name !== 'Airbnb' && selectedConnectorDetails.name !== 'Twitch' && selectedConnectorDetails.name !== 'Instagram' && selectedConnectorDetails.name !== 'WhatsApp Cloud' && selectedConnectorDetails.name !== 'Twitter'))">
									<div class="credentialDiv">
										<input type="text" class="form-control addConnectorInputs" name="appURLHandle" [(ngModel)]="appURLHandle" placeholder="{{ 'Application.AppURLHandle' | translate }}">
										<span>({{ 'Application.channelurlInfo' | translate }}
											<button style="background:none;padding: 0px;vertical-align: baseline;box-shadow: none;" type="button" class="btn " [ngbPopover]="channelurlInfoTemplate" placement="bottom">
												<span style="font-size:14px;color:#00b0ff !important;"> more info</span>
											</button>
										)</span>
										<br>
									</div>
									<div class="credentialDiv">
										<input type="text" class="form-control addConnectorInputs" name="appKey" [(ngModel)]="appKey" placeholder="{{ 'Application.AppKey' | translate }}" required>
										<span>({{ 'Application.appkeyInfo' | translate }})</span>
										<br>
										<span class="alert-error" style="margin-left:0px;">{{appKeyRequiredError}}</span>
									</div>
									<div class="credentialDiv">
										<input type="text" class="form-control addConnectorInputs" name="appSecret" [(ngModel)]="appSecret" placeholder="{{ 'Application.AppSecret' | translate }}" required>
										<span>({{ 'Application.appsecretInfo' | translate }})</span>
										<br>
										<span class="alert-error" style="margin-left:0px;">{{appSecretRequiredError}}</span>
									</div>
									<label *ngIf="selectedConnectorDetails && selectedConnectorDetails.hasOptionalParams">{{ 'Application.EnterOptionalParams' | translate }}</label>
									<div class="optionalPrams-div" *ngIf="selectedConnectorDetails && selectedConnectorDetails.name == 'APNS'">
										<p>{{ 'Application.apnsInfo1' | translate }}</p>
										<p>{{ 'Application.apnsInfo2' | translate }}</p>
										<p>{{ 'Application.apnsInfo3' | translate }}</p>
										<p>{{ 'Application.apnsInfo4' | translate }}</p>
										<!-- <p>{{ 'Application.apnsInfo55' | translate }}<br></p> -->
										<p>{{ 'Application.apnsInfo6' | translate }}<br></p>
										<p>	{{ 'Application.apnsInfo7' | translate }}</p>
										<p>{{ 'Application.apnsInfo8' | translate }}</p>
									</div>

									<div class="credentialDiv"
										*ngIf="selectedConnectorDetails && selectedConnectorDetails.hasOptionalParams">
										<div class="row">
											<div class="col-md-4">
												{{ 'Common.Key' | translate }}
												<div class="row" *ngFor="let x of selectedConnectorDetails.optionalParams | keyvalue; let l = count">
													<input *ngIf="x.key !== ''" type="text" class="form-control " name="key" [(ngModel)]="x.key" disabled>
												</div>
											</div>
											<div class="col-md-7">
												{{ 'Common.Value' | translate }}
												<div class="row" *ngFor="let x of selectedConnectorDetails.optionalParams | keyvalue; let i=index">
														<input *ngIf="x.key !== '' && x.key !== 'timezone'" type="text" class="form-control" name="value" [(ngModel)]="optionalParamsValue.value[i]" placeholder="{{ 'Common.Key'  | translate }}">
														<div *ngIf="x.key == 'timezone'">
															<ng-select [items]="timezoneSelect"
															bindLabel="name"
															  placeholder="Select Time Zone" multiple="false" [(ngModel)]="optionalParamsValue.value[i]" appendTo="body">
															</ng-select>
														</div>

												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</mat-tab>
						<mat-tab label="Bot Details" *ngIf="connectorName !== 'Fbmessenger' && connectorName !== 'Airbnb' && connectorName !== 'Twitch' && connectorName !== 'Instagram' && connectorName !== 'WhatsApp Cloud' && connectorName !== 'Twitter' && !chooseEmbedded">
							<div *ngIf="selectedConnectorDetails" class="bot-div">
								<label>{{ 'Application.EnterBotidNRegURL' | translate }}
									{{ selectedConnectorDetails.name }} {{ 'Application.AppAny' | translate }}.</label>
								<div class="credentialDiv">
									<input type="text" class="form-control addConnectorInputs" name="botDetailsId" [(ngModel)]="botDetailsId" placeholder="Bot id"
										[disabled]="disableBotIdAndUrlInput" required>
									<span class="alert-error">{{botDetailsIdRequiredError}}</span>
								</div>
								<div class="credentialDiv">
									<input type="text" class="form-control addConnectorInputs" name="registerUrl" [(ngModel)]="registerUrl"
										placeholder="{{ 'Application.WebhookURL' | translate }}" [disabled]="disableBotIdAndUrlInput" required>
									<span class="alert-error">{{registerUrlRequiredError}}</span>
								</div>
							</div>
						</mat-tab>
						<mat-tab label="Confirm" *ngIf="connectorName !== 'Fbmessenger' && connectorName !== 'Airbnb' && connectorName !== 'Twitch' && connectorName !== 'Instagram' && connectorName !== 'WhatsApp Cloud' && connectorName !== 'Twitter' && !chooseEmbedded">
							<div class="confirm-div">
								<label>{{ 'Application.ConnectorWillAdd' | translate }}.</label>
								<div class="row">
									<div class="col-md-4">
										<label *ngIf="selectedConnectorDetails">
											{{ 'Common.Connector' | translate }}:
											<div class="connectorName">{{ selectedConnectorDetails.name }}</div></label>
										<label>{{ 'Application.AppKey' | translate }}:
											<div class="connectorName">{{ appKey }}</div></label>
										<label>{{ 'Application.AppSecret' | translate }}:<div class="connectorName"> {{ appSecret }}</div></label>
									</div>
								</div>
							</div>
						</mat-tab>
					</mat-tab-group>
					<div class="row tabGroupBtn">
						<button *ngIf="connectorName !== 'Fbmessenger' && connectorName !== 'Airbnb' && connectorName !== 'Twitch' && connectorName !== 'Instagram' && connectorName !== 'WhatsApp Cloud' && connectorName !== 'Twitter'" type="button" class="reset-btn-login" [disabled]="backButtonDisable" [ngStyle]="{'display':backButtonDisable ?'none':'block'}" (click)="previousStep()">{{ 'Common.Back' | translate }}</button>
						<button *ngIf="connectorName !== 'Fbmessenger' && connectorName !== 'Airbnb' && connectorName !== 'Twitch' && connectorName !== 'Instagram'  && connectorName !== 'WhatsApp Cloud' && connectorName !== 'Twitter'" type="button" class="btn btn-info conNext" [disabled]="nextButtonDisable" [ngStyle]="{'display':displayNext}" (click)="nextStep()">{{ 'Common.Next' | translate }}</button>
						<button type="button" class="btn btn-info conNext" [ngStyle]="{'display':display}" (click)="addConnector(selectedConnectorDetails)">{{ 'Common.Submit' | translate }}</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="modal fade" role="dialog" id="activeUser">
	<div class="modal-dialog">
		<div class="modal-content modal-content-webhook" *ngIf="totalCountDetails">
			<!-- Modal Header -->
			<div class="modal-header">
				<div>
					<h4 class="modal-title">{{ totalCountDetails.heading }}</h4>
				</div>

				<div><button (click)="Cancel()" type="button" class="close closeButtonWebhook" data-dismiss="modal">&times;</button></div>
			</div>

			<!-- Modal body -->
			<div class="modal-body">
				<div class="row countdetailsDiv" id="t1">
					<div class="row" style="width:100%;">
						<label class="col-md-6 col-sm-6 col-xs-6 labelStyle">{{ totalCountDetails.detailsHeading1 }}:</label>
						<!-- <img *ngIf="todaysCountLoader" src="assets/images/uib-loading-500x500.gif" width="30px"> -->
						<label class="col-md-4 col-sm-4 col-xs-4" style="margin-left: -233px;">
							<form [formGroup]="monthForm">
								<select  formControlName="monthcontrol" style="width: 160px;">
								  <option [ngValue]="item.name" *ngFor="let item of monthSelect2">{{item.name}}</option>
							   </select>
								</form>
						</label>
						<label class="col-md-6 col-sm-6 col-xs-6 labelStyle" style="margin-top: 2px;">{{ totalCountDetails.detailsHeading6 }}:</label>
						<label class="col-md-4 col-sm-4 col-xs-4" style="margin-left: 424px;margin-top: -40px;">
							<form [formGroup]="monthForm2">
								<select  formControlName="monthcontrol2" style="width: 160px;">
								  <option [ngValue]="item.name" *ngFor="let item of monthSelect">{{item.name}}</option>
							   </select>
								</form>
						</label>
					</div>
					<div class="row" style="width:100%;">
						<label class="col-md-6 col-sm-6 col-xs-6 labelStyle">{{ totalCountDetails.detailsHeading2 }}:</label>

						<label  class="col-md-4 col-sm-4 col-xs-4" style="margin-left: -233px;">
							<form [formGroup]="yearForm">
							<select  formControlName="yearcontrol" style="width: 160px;">
								<!-- <option selected hidden>{{yearfromActive}}</option>  -->
								<option [ngValue]="item" *ngFor="let item of yearSelect1">{{item}}</option>
						   </select>
							</form>
						</label>
						<label class="col-md-6 col-sm-6 col-xs-6 labelStyle" style="margin-top: 2px;">{{ totalCountDetails.detailsHeading7 }}:</label>

						<label  class="col-md-4 col-sm-4 col-xs-4" style="margin-left: 424px; margin-top: -39px;">
							<form [formGroup]="yearForm2">
							<select  formControlName="yearcontrol2" style="width: 160px;">
								<!-- <option selected hidden>{{yeartoActive}}</option> -->
								<option [ngValue]="item" *ngFor="let item of yearSelect1">{{item}}</option>
						   </select>
							</form>
						</label>
					</div>
					<img  *ngIf="pageLoader" src="assets/images/uib-loading-500x500.gif"  alt="Page Loader" class="imageLoader" style="width: 50px;margin-left: 285px;" />
					<div class="col-md-11 col-xs-11 showChart" style="margin-bottom:3%;margin-left: 22px;">
						<div *ngIf="noRecords && !pageLoader" class="noRecordDiv" style="text-align: center;"><strong>{{ 'Dashboard.noData' | translate }}</strong></div>
						<div *ngIf="countzero" class="noRecordDiv" style="text-align: center;">
							<strong>No Data available</strong>
						   </div>


						<img *ngIf="!noRecords && sentChartOptions.dataProvider.length == 0 && !negativechoosen" src="assets/images/uib-loading-500x500.gif" alt="Sent Chart" style="width:50px;text-align:center;margin-left:273px;margin-top: -235px;">
						<div *ngIf="monthsexceeded" class="noRecordDiv" style="text-align: center;"><strong>Select date format between 12 months</strong></div>
						<div *ngIf="negativechoosen" class="noRecordDiv" style="text-align: center;"><strong>Please select valid date range</strong></div>

						<div id="content" [ngStyle]="{'display' : ((negativechoosen || monthsexceeded  || countzero || pageLoader || noRecords)  ) ? 'none' : 'block'}">
							<button type="button" id="report" style="background-color: white;border: none;float: right;border-radius: 10px;cursor: pointer;color: #cdcdcd;" (click)='!activeUserReport ? monthlyActiveUsersReportDownload() : false' title="Download" ><i class="fa fa-arrow-circle-down fa-2x"></i></button>

							<div *ngIf="!noRecords" id="chartdiv" class="chartStyle" style="height: 244px;width: 581px;">
						</div>
					</div>
					</div>
				</div>
			</div>

			<!-- Modal footer -->
			<div class="modal-footer">
				<button type="button" (click)="Cancel()" class="btn btn-default" data-dismiss="modal">{{ 'Common.Cancel' | translate }}</button>
				<button type="button" class="btn btn-info conNext" (click)="SubmitActiveUser()">Submit</button>
			</div>
		</div>
	</div>
</div>

<!-- countDetails Modal -->
<div class="modal fade" role="dialog" id="countDetails">
	<div class="modal-dialog">
		<div class="modal-content modal-content-webhook" *ngIf="totalCountDetails">
			<!-- Modal Header -->
			<div class="modal-header">
				<div>
					<h4 class="modal-title">{{ totalCountDetails.heading }}</h4>
				</div>
				<div>
					<p></p>
				</div>
				<div><button type="button" class="close closeButtonWebhook" data-dismiss="modal" (click)="this.audioDurationLoad=false">&times;</button></div>
			</div>

			<!-- Modal body -->
			<div class="modal-body">
				<div class="row countdetailsDiv">
					<div class="row" style="width:100%;">
						<label class="col-md-6 col-sm-6 col-xs-6 labelStyle">{{ totalCountDetails.detailsHeading1 }}:</label>
						<img alt="" *ngIf="todaysCountLoader" src="assets/images/uib-loading-500x500.gif" width="30px">
						<label *ngIf="!todaysCountLoader && !audioDurationLoad" class="col-md-2 col-sm-2 col-xs-2 labelStyle" style="text-align:end;">{{ totalCountDetails.todaysCount | number : '1.' }} <span *ngIf="this.audioDurationLoad">(s)</span></label>
						<label *ngIf="!todaysCountLoader && audioDurationLoad" class="col-md-3 col-sm-3 col-xs-3 labelStyle" style="text-align:end;">{{ audioTodayCount  }}</label>
					</div>
					<div class="row" style="width:100%;">
						<label class="col-md-6 col-sm-6 col-xs-6 labelStyle">{{ totalCountDetails.detailsHeading2 }}:</label>
						<img alt="" *ngIf="weeklyCountLoader" src="assets/images/uib-loading-500x500.gif" width="30px">
						<label *ngIf="!weeklyCountLoader && !audioDurationLoad" class="col-md-2 col-sm-2 col-xs-2 labelStyle" style="text-align:end;">{{ totalCountDetails.weeklyCount | number : '1.' }}<span *ngIf="this.audioDurationLoad">(s)</span></label>
						<label *ngIf="!weeklyCountLoader && audioDurationLoad" class="col-md-3 col-sm-3 col-xs-3 labelStyle" style="text-align:end;">{{ audioWeeklyCount  }}</label>
					</div>
					<div class="row" style="width:100%;">
						<label class="col-md-6 col-sm-6 col-xs-6 labelStyle">{{ totalCountDetails.detailsHeading3 }}:</label>
						<img alt="" *ngIf="monthlyCountLoader" src="assets/images/uib-loading-500x500.gif" width="30px">
						<label *ngIf="!monthlyCountLoader && !audioDurationLoad" class="col-md-2 col-sm-2 col-xs-2 labelStyle" style="text-align:end;">{{ totalCountDetails.monthlyCount | number : '1.' }}<span *ngIf="this.audioDurationLoad">(s)</span></label>
						<label *ngIf="!monthlyCountLoader && audioDurationLoad" class="col-md-3 col-sm-3 col-xs-3 labelStyle" style="text-align:end;">{{ audioMonthlyCount  }}</label>
					</div>
					<div class="row" style="width:100%;">
						<label class="col-md-6 col-sm-6 col-xs-6 labelStyle">{{ totalCountDetails.detailsHeading4 }}:</label>
						<img alt="" *ngIf="yearlyCountLoader" src="assets/images/uib-loading-500x500.gif" width="30px">
						<label *ngIf="!yearlyCountLoader && !audioDurationLoad" class="col-md-2 col-sm-2 col-xs-2 labelStyle" style="text-align:end;">{{  totalCountDetails.yearlyCount | number : '1.' }}</label>
						<label *ngIf="!yearlyCountLoader && audioDurationLoad" class="col-md-3 col-sm-3 col-xs-3 labelStyle" style="text-align:end;">{{ audioYearlyCount  }}</label>
					</div>
				</div>
				<hr>
				<div class="row dateFilterInput">
					<!--Date Range Drop Down-->
					<div class="col-md-7 datepickerStyle">
						<select name="dateRange" style="width: 100%;padding:10px;" class="dateRange shadow" id="dateRange" [(ngModel)]="selectedDateRange" (change)="switchDateRange();">
							<option value="last30">{{ 'Application.last30' | translate }}</option>
							<option value="choosedate">{{ 'Application.dateRange' | translate }}</option>
						</select>
						<div *ngIf="selectedDateRange == 'choosedate'">
							<input class="form-control dateSelectionDiv" #drp="bsDaterangepicker" bsDaterangepicker [(ngModel)]="bsRangeValue" [maxDate]="bsValue" [bsConfig]="{ adaptivePosition: true,containerClass: 'theme-default',rangeInputFormat: 'DD-MM-YYYY' }" (bsValueChange)="selectDate($event)">
						</div>
					</div>
					<!--<div class="col-md-6 datepickerStyle">
						<input class="form-control" #drp="bsDaterangepicker" bsDaterangepicker [(ngModel)]="bsRangeValue" [maxDate]="bsValue" [bsConfig]="{ adaptivePosition: true,containerClass: 'theme-default',rangeInputFormat: 'DD-MM-YYYY' }" (bsValueChange)="selectDate($event)">
					</div>
					<div class="col-md-6 datepickerIconStyle pt-2">
						<i class="fa fa-calendar fa-lg" (click)="drp.toggle()" [attr.aria-expanded]="drp.isOpen" aria-hidden="true"></i>
					</div>-->
				</div>
				<div class="row" *ngIf="dateRangeDiv">
					<div class="dateRangeDiv" *ngIf="dateRangeDiv && !audioDurationLoad">
						{{ totalCountDetails.heading }}: {{ dateRangeCount  | number : '1.'}} <span *ngIf="this.audioDurationLoad">(s)</span>
					</div>
					<div class="dateRangeDiv" *ngIf="dateRangeDiv && audioDurationLoad">
						{{ totalCountDetails.heading }}: {{ dateRangeCount }}
					</div>
				</div>
			</div>

			<!-- Modal footer -->
			<div class="modal-footer">
				<button type="button" class="btn btn-default" data-dismiss="modal" (click)= "this.audioDurationLoad=false" >{{ 'Common.Cancel' | translate }}</button>
				<button type="button" class="btn btn-info" *ngIf="userCountClick" (click)="dateRangeCounts('userDate')">{{ 'Common.Submit' | translate }}</button>
				<button type="button" class="btn btn-info" *ngIf="messageSentClick" (click)="dateRangeCounts('msgSentDate')">{{ 'Common.Submit' | translate }}</button>
				<button type="button" class="btn btn-info" *ngIf="messageReceivedClick" (click)="dateRangeCounts('msgReceivedDate')">{{ 'Common.Submit' | translate }}</button>
				<button type="button" class="btn btn-info" *ngIf="connectorMsgSentClick" (click)="dateRangeCounts('connectorMsgSentDate')">{{ 'Common.Submit' | translate }}</button>
				<button type="button" class="btn btn-info" *ngIf="connectorHsmMsgSentClick" (click)="dateRangeCounts('connectorHsmMsgSentDate')">{{ 'Common.Submit' | translate }}</button>
				<button type="button" class="btn btn-info" *ngIf="receivedNotificationClick" (click)="dateRangeCounts('receivedNotificationDate')">{{ 'Common.Submit' | translate }}</button>
				<button type="button" class="btn btn-info" *ngIf="tempalteCoClick" (click)="dateRangeCounts('tempalteCoDate')">{{ 'Common.Submit' | translate }}</button>
				<button type="button" class="btn btn-info" *ngIf="audiototextClick" (click)="dateRangeCounts('audioDuration')">{{ 'Common.Submit' | translate }}</button>

			</div>
		</div>
	</div>
</div>

<!-- Download Report Modal -->
<div class="modal fade" role="dialog" id="downloadReport">
	<div class="modal-dialog">
		<div class="modal-content modal-content-webhook" *ngIf="downloadReport">
			<!-- Modal Header -->
			<div class="modal-header">
				<div style="margin-bottom: 10px;">
					<h4 class="modal-title">Message Count Report</h4>
				</div>
				<div>
					<p></p>
				</div>
				<div><button type="button" class="close closeButtonWebhook" data-dismiss="modal" (click)="closeReportModel()">&times;</button></div>
			</div>

			<!-- Modal body -->
			<div class="modal-body">
				<div class="row countdetailsDiv">
					<div class="row" style="width:100%;">

					</div>

				</div>

				<div class="row dateFilterInput">
					<div class="col-md-7 datepickerStyle">
						<select name="dateRange" style="width: 100%;padding:10px;" class="dateRange shadow" id="dateRange" [(ngModel)]="selectedReportDateRange" (change)="switchReportDateRange();">
							<option value="today">{{ 'Application.today' | translate }}</option>
							<option value="last7">{{ 'Application.last7' | translate }}</option>
							<option value="last30">{{ 'Application.last30' | translate }}</option>
							<option value="choosedate">{{ 'Application.dateRange' | translate }}</option>
						</select>
						<div *ngIf="selectedReportDateRange == 'choosedate'">
							<input class="form-control dateSelectionDiv" #drp="bsDaterangepicker" bsDaterangepicker [(ngModel)]="bsRangeValue" [maxDate]="bsValue" [bsConfig]="{ adaptivePosition: true,containerClass: 'theme-default',rangeInputFormat: 'DD-MM-YYYY' }" (bsValueChange)="reportDate($event)">
						</div>
					</div>

					<!--<div class="col-md-6 datepickerStyle">
						<input class="form-control" #drp="bsDaterangepicker" bsDaterangepicker [(ngModel)]="bsRangeValue" [maxDate]="bsValue" [bsConfig]="{ adaptivePosition: true,containerClass: 'theme-default',rangeInputFormat: 'DD-MM-YYYY' }" (bsValueChange)="reportDate($event)">
					</div>
					<div class="col-md-6 datepickerIconStyle pt-2">
						<i class="fa fa-calendar fa-lg" (click)="drp.toggle()" [attr.aria-expanded]="drp.isOpen" aria-hidden="true"></i>
					</div>-->
				</div>
				<div class="col-md-4"></div>
					<div class="col-md-4" style="margin: auto;display: block;" *ngIf="reportDownloadBtn">
						<img alt="" *ngIf="reportloadershow" src="assets/images/uib-loading-500x500.gif" style="width: 50px;position:absolute;transform: translate(100%, -95%);">
						<button type="button" id="report" style="padding: 3% 10%;color: white;font-size: 16px;border-radius: 25px;background: #00b0ff;border:none;margin-top: 5%;" [ngStyle]="{'background-color' : activeUserReport ? '#cdcdcd' : '#00b0ff', 'cursor': activeUserReport ? 'no-drop':'pointer'}" (click)='!activeUserReport ? reportDownload() : false'>Download (xlsx)</button>
					</div>
					<div class="col-md-4" ></div>

			</div>

			<!-- Modal footer -->
			<div class="modal-footer">
				<button type="button" class="btn btn-default" id="close" data-dismiss="modal"  (click)="closeReportModel()">{{ 'Common.Close' | translate }}</button>
			</div>
		</div>
	</div>
</div>
<!-- tempalteCount Modal -->
<div class="modal fade" role="dialog" id="templateCount">
	<div class="modal-dialog">
		<div class="modal-content modal-content-webhook" *ngIf="totalCountDetails">
			<!-- Modal Header -->
			<div class="modal-header">
				<div>
					<h4 class="modal-title">{{ totalCountDetails.heading }}</h4>
				</div>
				<div>
					<p>{{ totalCountDetails.subHeading }}</p>
				</div>
				<div><button type="button" class="close closeButtonWebhook" data-dismiss="modal">&times;</button></div>
			</div>

			<!-- Modal body -->
			<div class="modal-body">
				<div class="row countdetailsDiv" style="padding-bottom: 15px;">
					<div class="" style="width:100%;height: 300px; overflow-y: scroll;padding-left: 10%;" >
						<div class="mx-auto">
						<h6 *ngIf="paginationCount==0 && !templateLoader" class="text-center" >No templates found</h6>
						</div>
							<table *ngIf="totalTemplate!==0" style="width: 70%;">
								<tr *ngFor="let item of templateConnectors">
									<td for="" style="padding-bottom: 10px;"><h6>{{item.title}}</h6>
									<table style="width: 100%;">
										<th style="width: 70%;"><h6 *ngIf="paginationCount!==0">Template Name</h6></th>
										<th style="width: 40%;"><h6 *ngIf="paginationCount!==0">Total Count</h6></th>
									  <tr *ngFor="let data of item.template | keys;">
										<td class="word" style="padding-left: 5px;">{{ data.value[0] }}</td>
										 <td  *ngIf="!templateLoader">{{data.value[1]}}</td>
										<td><img alt="" *ngIf="templateLoader" src="assets/images/uib-loading-500x500.gif" width="30px"></td>
									  </tr>

									</table>
								  </td>
								</tr>
								</table>
						<div *ngIf="!templateLoader" style="display: flex;justify-content: center;padding-right: 55px;">
							<img alt="" *ngIf="templateLoader" src="assets/images/uib-loading-500x500.gif" width="70px">
						</div>
					</div>
				</div>
				<ngb-pagination [collectionSize]="paginationCount" [disabled]="false" [(page)]="page" [maxSize]="5"
				[rotate]="true" (pageChange)="pageChanged2($event)" [pageSize]="1"> </ngb-pagination>
				<hr>
				<div class="row dateFilterInput">
					<div class="col-md-7 datepickerStyle">
						<select name="dateRange" style="width: 100%;padding:10px;" class="dateRange shadow" id="dateRange" [(ngModel)]="selectedDateRange" (change)="switchDateRange();">
							<option value="last30">{{ 'Application.last30' | translate }}</option>
							<option value="choosedate">{{ 'Application.dateRange' | translate }}</option>
						</select>
						<div *ngIf="selectedDateRange == 'choosedate'">
							<input class="form-control dateSelectionDiv" #drp="bsDaterangepicker" bsDaterangepicker [(ngModel)]="bsRangeValue" [maxDate]="bsValue" [bsConfig]="{ adaptivePosition: true,containerClass: 'theme-default',rangeInputFormat: 'DD-MM-YYYY' }" (bsValueChange)="selectDate($event)">
						</div>
					</div>

					<!--<div class="col-md-6 datepickerStyle">
						<input class="form-control" #drp="bsDaterangepicker" bsDaterangepicker [(ngModel)]="bsRangeValue" [maxDate]="bsValue" [bsConfig]="{ adaptivePosition: true,containerClass: 'theme-default',rangeInputFormat: 'DD-MM-YYYY' }" (bsValueChange)="selectDate($event)">
					</div>
					<div class="col-md-6 datepickerIconStyle pt-2">
						<i class="fa fa-calendar fa-lg" (click)="drp.toggle()" [attr.aria-expanded]="drp.isOpen" aria-hidden="true"></i>
					</div>-->

				</div>
				<div class="row" *ngIf="dateRangeDiv">
					<div class="dateRangeDiv">
						{{ totalCountDetails.heading }}: {{ dateRangeCount }}
					</div>
				</div>
			</div>

			<!-- Modal footer -->
			<div class="modal-footer">
				<button type="button" class="btn btn-default" data-dismiss="modal" (click)="dataRangeCancel()">{{ 'Common.Cancel' | translate }}</button>

				<button type="button" class="btn btn-info" *ngIf="tempalteCoClick" (click)="dateRangeCounts('tempalteCoDate')">{{ 'Common.Submit' | translate }}</button>
			</div>
		</div>
	</div>
</div>

<ng-template #channelurlInfoTemplate>
    <p style="font-size:12px;margin-bottom: 0px !important;">
		&#9679; For Whatsapp - https://wa.me/xxxx
		<br/>
		&#9679; For Facebook - https://m.me/yyy
		<br/>
		&#9679; For Telegram - https://t.me/zzz
	</p>
</ng-template>
